import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AssetsService } from 'src/app/services/assets.service';

@Component({
  selector: 'app-asset-history',
  templateUrl: './asset-history.component.html',
  styleUrls: ['./asset-history.component.css'],
})
export class AssetHistoryComponent implements OnInit, AfterViewInit {
  constructor(
    private fb: UntypedFormBuilder,
    private assetsService: AssetsService,
  ) {}

  assetHistryList: HistoryDetails[] = [];
  searchPerformed = false;
  assetType = '';
  make = '';
  model = '';

  ngOnInit(): void {}

  displayedColumns: string[] = [
    'assetAssignedToEmp',
    'empAssignedDate',
    'empEndDate',
    'status',
  ];
  dataSource = new MatTableDataSource<HistoryDetails>(this.assetHistryList);

  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  private parseDateString(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return value;
    }

    // Handle array format [year, month, day]
    if (Array.isArray(value) && value.length === 3) {
      const year = Number(value[0]);
      const month = Number(value[1]) - 1;
      const day = Number(value[2]);

      if (
        !Number.isNaN(day) &&
        !Number.isNaN(month) &&
        !Number.isNaN(year) &&
        day >= 1 &&
        day <= 31 &&
        month >= 0 &&
        month <= 11
      ) {
        // create date at midday to avoid timezone offset shifting the day
        return new Date(year, month, day, 12, 0, 0, 0);
      }
    }

    // Handle string format DD/MM/YYYY
    const dateString = String(value).trim();
    const parts = dateString.split('/');

    if (parts.length === 3) {
      const day = Number(parts[0]);
      const month = Number(parts[1]) - 1;
      const year = Number(parts[2]);

      if (
        !Number.isNaN(day) &&
        !Number.isNaN(month) &&
        !Number.isNaN(year) &&
        day >= 1 &&
        day <= 31 &&
        month >= 0 &&
        month <= 11
      ) {
        // create date at midday to avoid timezone offset shifting the day
        return new Date(year, month, day, 12, 0, 0, 0);
      }
    }

    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  searchAsset($event: Event) {
    this.assetHistryList = [];
    const searchAssetId = ($event.target as HTMLInputElement).value;
    if (searchAssetId.trim() !== '') {
      this.searchPerformed = true;
      this.assetsService.fetchAssetHistory(searchAssetId).subscribe((res) => {
        console.log(res);
        if (res.assetsHistory && res.assetsHistory.length > 0) {
          this.assetType = res.assetType || '';

          if (this.assetType.toLowerCase() === 'car') {
            this.make = res.make + ' ' + res.model || '';
            this.model = res.number || '';
          } else {
            this.make = res.electronicModel || '';
            this.model = res.electronicSerialNumber || '';
          }
        } else {
          this.assetType = '';
          this.make = '';
          this.model = '';
        }

        this.assetHistryList = res.assetsHistory.map((e: any) => ({
          assetAssignedToEmp: e.empId,
          empAssignedDate: this.parseDateString(e.assetStartDate),
          empEndDate: this.parseDateString(e.assetEndDate),
          status: e.status,
        }));
        this.dataSource = new MatTableDataSource<HistoryDetails>(
          this.assetHistryList,
        );
        this.dataSource.paginator = this.paginator;
      });
    } else {
      this.searchPerformed = false;
      this.dataSource = new MatTableDataSource<HistoryDetails>([]);
    }
  }
}

export interface HistoryDetails {
  assetAssignedToEmp: string;
  empAssignedDate: Date;
  empEndDate: Date;
  status: string;
}
